// Vendor imports
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const UserAvatar = require('client-v2/common/components/user-avatar')
const Icon = require('client-v2/common/containers/icons/component')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('IntoHeader')

function IntoHeader(props) {
  const { user } = props
  return (
    tag('div', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag('a', {
        className: bem.element('logo-container'),
        href: '/'
      },
        tag(Icon, {
          className: bem.element('logo-icon'),
          id: 'mix-logomark'
        }),
        tag(Icon, {
          className: bem.element('logo-text'),
          id: 'mix-logotype'
        })
      ),
      user && tag(UserAvatar, {
        className: bem.element('avatar'),
        user,
        badge: false,
        href: `/u/${user.username}`,
        visible: true
      })
    )
  )
}

module.exports = IntoHeader
